export default {
  CHANNEL: 'channel',
  YOUTUBE_FEED: 'youtube-feed',
};



// WEBPACK FOOTER //
// ./src/transport/constants/channel-types.js